<div class="eek2-result">
	<div class="eek2-note disclaimer">
		<strong>{{ copy.disclaimerTitle }}</strong>
		<div>{{ copy.disclaimerBody }}</div>
	</div>

	<div *ngIf="vm.riskTriggered" class="eek2-note safety">
		<strong>{{ copy.safetyTitle }}</strong>
		<div>{{ copy.safetyBody }}</div>
		<div *ngIf="vm.riskText" class="eek2-crisis">{{ vm.riskText }}</div>
	</div>

	<div class="eek2-card">
		<div class="eek2-header">
			<div>
				<h2 class="eek2-title">{{ assessment?.title || questions?.fullTitle || copy.title }}</h2>
				<div *ngIf="questions?.fullTitle" class="eek2-subtitle">{{ questions?.fullTitle }}</div>
			</div>
			<div *ngIf="vm.dateText" class="eek2-date">
				<span>{{ copy.completed }}</span>
				<strong>{{ vm.dateText }}</strong>
			</div>
		</div>

		<div class="eek2-summary">
			<span class="eek2-count">{{ vm.summaryCount }}/{{ vm.gauges.length }}</span>
			<span class="eek2-pill" [ngClass]="vm.summaryCount > 0 ? 'warn' : 'good'">
				{{ vm.summaryCount > 0 ? (vm.summaryCount + ' ' + copy.summaryWarn) : copy.summaryGood }}
			</span>
		</div>

		<div *ngIf="showHistoryButton" class="eek2-actions">
			<button type="button" class="eek2-history-btn" (click)="onHistoryRequested()">{{ copy.viewHistory }}</button>
		</div>
	</div>

	<div class="eek2-gauges">
		<article class="eek2-gauge-card" *ngFor="let gauge of vm.gauges">
			<h3 class="eek2-gauge-title">{{ gauge.label }}</h3>
			<p class="eek2-gauge-description" *ngIf="gauge.description">{{ gauge.description }}</p>

			<svg class="eek2-gauge-svg" viewBox="0 0 200 122" role="img" [attr.aria-label]="gauge.label + ': ' + gauge.score + ' / ' + gauge.max">
				<defs>
					<linearGradient [attr.id]="'eek2-grad-' + gauge.key" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stop-color="var(--eek2-gauge-low)" />
						<stop offset="50%" stop-color="var(--eek2-gauge-mid)" />
						<stop offset="100%" stop-color="var(--eek2-gauge-high)" />
					</linearGradient>
				</defs>

				<path [attr.d]="gaugeArcPath" fill="none" stroke="#eceef1" stroke-width="16" stroke-linecap="round"></path>
				<path [attr.d]="gaugeArcPath" fill="none" [attr.stroke]="'url(#eek2-grad-' + gauge.key + ')'" stroke-width="14" stroke-linecap="round"></path>

				<line
					[attr.x1]="gauge.cutoffInner.x"
					[attr.y1]="gauge.cutoffInner.y"
					[attr.x2]="gauge.cutoffOuter.x"
					[attr.y2]="gauge.cutoffOuter.y"
					stroke="var(--eek2-ink)"
					stroke-width="2.5"></line>
				<text
					[attr.x]="gauge.cutoffLabel.x"
					[attr.y]="gauge.cutoffLabel.y"
					text-anchor="middle"
					font-size="11"
					font-weight="800"
					fill="var(--eek2-ink)"
					dominant-baseline="middle">
					{{ gauge.cutoff }}
				</text>

				<g class="eek2-needle" [style.transform]="'rotate(' + gauge.needleDeg + 'deg)'">
					<polygon [attr.points]="gaugeNeedlePoints" fill="var(--eek2-ink)" stroke="var(--eek2-ink)" stroke-width="1" stroke-linejoin="round"></polygon>
				</g>
				<circle cx="100" cy="100" r="5.5" fill="var(--eek2-ink)"></circle>
			</svg>

			<div class="eek2-gauge-score">
				<span class="eek2-num">{{ gauge.score }}</span>
				<span class="eek2-max">/ {{ gauge.max }}</span>
			</div>

			<div class="eek2-statusWrap">
				<span class="eek2-status" [ngClass]="gauge.above ? 'warn' : 'good'">
					<span class="eek2-dot" aria-hidden="true"></span>
					{{ gauge.statusLabel }}
				</span>
			</div>
		</article>
	</div>
</div>
